<script lang="ts">
							import SectionComponent from '$lib/section/SectionComponent.svelte';
							import copy from "copy-to-clipboard"; 
							import { onMount } from "svelte";
							import PrevNextSection from '$lib/prevNext/PrevNextSection.svelte';

							interface ComponentProps {
								setVisible: (id: string, v: boolean) => void;
							}
							let { setVisible }: ComponentProps = $props();
							
							const visibleById = $state<Record<string, boolean>>({});

							/**
               * This function will go through all the 'pre' elements
               * on the page and add a copy button to them.
               * Thanks to: https://slavbasharov.com/blog/adding-click-to-copy-code-markdown-blog
               */
              onMount(() => {
                  const codeBlocks = document.querySelectorAll("pre");
                  codeBlocks.forEach((block) => {
                      const copyPrompt = document.createElement("div");
                      copyPrompt.className = "copy-prompt";
                      const copyPromptText = document.createElement("p");
                      copyPromptText.innerHTML = "👆 Click to copy";
                      copyPromptText.className = 'copy-prompt-p';
                      const copyIcon = document.createElement("img");
                      copyIcon.src = "/icons/copy-icon.svg";
                      copyIcon.className = "copy-prompt-img";
                      copyPrompt.appendChild(copyIcon);
                      copyPrompt.appendChild(copyPromptText);
                      block.appendChild(copyPrompt);
											block.querySelector('.copy-prompt > p')?.addEventListener('click', () => {
												if (block.querySelector('code')?.textContent !== null && block.querySelector('code')?.textContent !== undefined) {
													copy(block.querySelector('code')!.textContent!);
												}
												if (block.querySelector('.copy-prompt > p')?.innerHTML !== null && block.querySelector('.copy-prompt > p')?.innerHTML !== undefined) {
													block.querySelector('.copy-prompt > p')!.innerHTML = 'Copied!';
													setTimeout(() => {
														block.querySelector('.copy-prompt > p')!.innerHTML = '👆 Click to copy';
													}, 1000);
												}
											});
                  });
              });
		let prevLink= '/Documentation/Defining_an_Editor/Projections_for_Limited_Concepts';
    let nextLink= '/Documentation/Defining_an_Editor/Global_Projections';
    
</script>
<PrevNextSection {prevLink} {nextLink} />
<SectionComponent tag="h1" 
  id="binary-expressions-1"
  bind:intersecting={visibleById["binary-expressions-1"]}
  onIntersectChange={(visible) => setVisible("binary-expressions-1", visible)}
>Binary Expressions</SectionComponent>
<p>In <a href="/Documentation/Defining_an_Editor">Defining an Editor</a> it was already mentioned
that projections cannot be specified for <em>binary expression concepts</em>.
The editor offers specialized support for binary expressions, which will not function properly
if a user-defined projection is applied.</p>
<SectionComponent tag="h2" 
  id="symbols-2"
  bind:intersecting={visibleById["symbols-2"]}
  onIntersectChange={(visible) => setVisible("symbols-2", visible)}
>Symbols</SectionComponent>
<p>You can, however, indicate the string to be used as the operator. This string is called the <strong>symbol</strong>.
It is defined in the <code>.edit</code> file, as shown below.</p>
<pre class="language-freon"><code class="language-freon">// Insurance/src/defs/editor-expressions-default.edit#L18-L29

MinusExpression  &#123;
    symbol = "-"
&#125;
PlusExpression &#123;
    symbol = "+"
&#125;
MultiplyExpression &#123;
    symbol = "*"
&#125;
DivideExpression &#123;
    symbol = "/"
&#125;</code></pre>


<PrevNextSection {prevLink} {nextLink} />